type Range = [number, number];

/**
 * Map a value from a range to a new range. E.g.: Value 50, currentRange [0, 100], newRange [0, 200] it is going to return 100
 * @param value value to map from one range to another
 * @param currentRange Current range that the value is in
 * @param newRange New range that you will get the value
 */
export function remap(value: number, currentRange: Range, newRange: Range) {
  const [currentMin, currentMax] = currentRange;
  const [newMin, newMax] = newRange;

  return ((value - currentMin) * (newMax - newMin)) / (currentMax - currentMin) + newMin;
}
